/**
 * The page's one request function, as the work pane reaches it.
 *
 * `request` belongs to the page module (`main.tsx`): a refused write there re-reads queries through
 * the page's own query client, and a test mounts the page module afresh for each page, client
 * included. The work pane (`work-pane.tsx`) cannot import the page module, which mounts the app as
 * it loads, so the page hands its `request` here when it loads and the pane's cards call `request`
 * exactly as they did inside `main.tsx`. One page is loaded at a time; the newest one answers.
 */
type PageRequest = (path: string, body?: object) => Promise<unknown>;

let pageRequest: PageRequest | null = null;

/** Called once by the page module as it loads. */
export function providePageRequest(next: PageRequest): void {
  pageRequest = next;
}

export function request(path: string, body?: object): Promise<unknown> {
  if (pageRequest === null) throw new Error("The page has not provided its request function.");
  return pageRequest(path, body);
}
